import React, { useState } from 'react';
import TableHeader from './TableHeader';

// ✅ TABLE COLUMNS DEFINITION
const tableColumns = [
    { label: "#", width: "50px", rowSpan: 2, color: "#009ed6" },
    { label: "Center Name", width: "200px", rowSpan: 2, color: "#009ed6" },
    { label: "Date", width: "150px", rowSpan: 2, color: "#009ed6" },
    {
        label: "Lead", colSpan: 2, color: "#009ed6",
        subColumns: [
            { key: "converted_lead", label: "Converted", width: "85px", color: "#009ed6" },
            { key: "total_lead", label: "Total", width: "60px", color: "#009ed6" },
        ],
    },
    {
        key: "appointments", label: "Appointments", width: "120px", rowSpan: 2, color: "#009ed6"
    },
    {
        label: "Package Booked", colSpan: 3, color: "#009ed6",
        subColumns: [
            { key: "package_booked_snb", label: "SNB", width: "50px", color: "#009ed6" },
            { key: "package_booked_sdt", label: "SDT", width: "50px", color: "#009ed6" },
            { key: "package_booked_snb_sdt", label: "SNB+SDT", width: "80px", color: "#009ed6" },
        ]
    },
    {
        label: "Package Completed", colSpan: 3, color: "#009ed6",
        subColumns: [
            { key: "package_commpleted_snb", label: "SNB", width: "50px", color: "#009ed6" },
            { key: "package_commpleted_sdt", label: "SDT", width: "50px", color: "#009ed6" },
            { key: "package_commpleted_snb_sdt", label: "SNB+SDT", width: "80px", color: "#009ed6" },
        ]
    },
    {
        label: "Treatment Scheduled", colSpan: 3, color: "#009ed6",
        subColumns: [
            { key: "treatment_scheduled_snb", label: "SNB", width: "50px", color: "#009ed6" },
            { key: "treatment_scheduled_sdt", label: "SDT", width: "50px", color: "#009ed6" },
            { key: "treatment_scheduled_snb_sdt", label: "SNB+SDT", width: "80px", color: "#009ed6" },
        ]
    },
    {
        label: "Treatment Completed", colSpan: 3, color: "#009ed6",
        subColumns: [
            { key: "treatment_completed_snb", label: "SNB", width: "50px", color: "#009ed6" },
            { key: "treatment_completed_sdt", label: "SDT", width: "50px", color: "#009ed6" },
            { key: "treatment_completed_snb_sdt", label: "SNB+SDT", width: "80px", color: "#009ed6" },
        ]
    },
    {
        label: "Machines", colSpan: 2, color: "#009ed6",
        subColumns: [
            { key: "machines_snb", label: "SNB", width: "50px", color: "#009ed6" },
            { key: "machines_sdt", label: "SDT", width: "50px", color: "#009ed6" },
        ]
    },
    {
        label: "CUI", colSpan: 2, color: "#009ed6",
        subColumns: [
            { key: "cui_snb", label: "SNB", width: "50px", color: "#009ed6" },
            { key: "cui_sdt", label: "SDT", width: "50px", color: "#009ed6" },
        ]
    },
];

// ✅ STATIC DUMMY DATA - States with Centers
const stateDummyData = {
    "Uttrakhand": [
        {
            "#": 1,
            "Center Name": "Shivpuri",
            "Date": "2025-11-27",
            converted_lead: 25, total_lead: 120, appointments: 50,
            package_booked_snb: 5, package_booked_sdt: 3, package_booked_snb_sdt: 8,
            package_commpleted_snb: 2, package_commpleted_sdt: 1, package_commpleted_snb_sdt: 3,
            treatment_scheduled_snb: 12, treatment_scheduled_sdt: 8, treatment_scheduled_snb_sdt: 20,
            treatment_completed_snb: 10, treatment_completed_sdt: 6, treatment_completed_snb_sdt: 16,
            machines_snb: 4, machines_sdt: 2, cui_snb: 85, cui_sdt: 82,
        },
        {
            "#": 2,
            "Center Name": "Dehradun",
            "Date": "2025-11-27",
            converted_lead: 18, total_lead: 95, appointments: 42,
            package_booked_snb: 4, package_booked_sdt: 2, package_booked_snb_sdt: 6,
            package_commpleted_snb: 2, package_commpleted_sdt: 1, package_commpleted_snb_sdt: 3,
            treatment_scheduled_snb: 10, treatment_scheduled_sdt: 6, treatment_scheduled_snb_sdt: 16,
            treatment_completed_snb: 8, treatment_completed_sdt: 5, treatment_completed_snb_sdt: 13,
            machines_snb: 3, machines_sdt: 2, cui_snb: 88, cui_sdt: 84,
        }
    ],
    "Maharashtra": [
        {
            "#": 1,
            "Center Name": "Pune",
            "Date": "2025-11-27",
            converted_lead: 15, total_lead: 80, appointments: 35,
            package_booked_snb: 3, package_booked_sdt: 2, package_booked_snb_sdt: 5,
            package_commpleted_snb: 1, package_commpleted_sdt: 1, package_commpleted_snb_sdt: 2,
            treatment_scheduled_snb: 8, treatment_scheduled_sdt: 5, treatment_scheduled_snb_sdt: 13,
            treatment_completed_snb: 6, treatment_completed_sdt: 4, treatment_completed_snb_sdt: 10,
            machines_snb: 3, machines_sdt: 1, cui_snb: 89, cui_sdt: 86,
        },
        {
            "#": 2,
            "Center Name": "Mumbai",
            "Date": "2025-11-27",
            converted_lead: 20, total_lead: 105, appointments: 45,
            package_booked_snb: 4, package_booked_sdt: 3, package_booked_snb_sdt: 7,
            package_commpleted_snb: 2, package_commpleted_sdt: 1, package_commpleted_snb_sdt: 3,
            treatment_scheduled_snb: 11, treatment_scheduled_sdt: 7, treatment_scheduled_snb_sdt: 18,
            treatment_completed_snb: 9, treatment_completed_sdt: 5, treatment_completed_snb_sdt: 14,
            machines_snb: 3, machines_sdt: 2, cui_snb: 87, cui_sdt: 85,
        }
    ],
    "West Bengal": [
        {
            "#": 1,
            "Center Name": "Kolkata",
            "Date": "2025-11-27",
            converted_lead: 28, total_lead: 140, appointments: 60,
            package_booked_snb: 6, package_booked_sdt: 4, package_booked_snb_sdt: 10,
            package_commpleted_snb: 3, package_commpleted_sdt: 2, package_commpleted_snb_sdt: 5,
            treatment_scheduled_snb: 14, treatment_scheduled_sdt: 10, treatment_scheduled_snb_sdt: 24,
            treatment_completed_snb: 12, treatment_completed_sdt: 8, treatment_completed_snb_sdt: 20,
            machines_snb: 5, machines_sdt: 3, cui_snb: 81, cui_sdt: 79,
        },
        {
            "#": 2,
            "Center Name": "Siddhi Vinayak",
            "Date": "2025-11-27",
            converted_lead: 26, total_lead: 130, appointments: 55,
            package_booked_snb: 5, package_booked_sdt: 4, package_booked_snb_sdt: 9,
            package_commpleted_snb: 2, package_commpleted_sdt: 2, package_commpleted_snb_sdt: 4,
            treatment_scheduled_snb: 13, treatment_scheduled_sdt: 9, treatment_scheduled_snb_sdt: 22,
            treatment_completed_snb: 11, treatment_completed_sdt: 7, treatment_completed_snb_sdt: 18,
            machines_snb: 4, machines_sdt: 3, cui_snb: 83, cui_sdt: 80,
        }
    ]
};

// ✅ STATIC DATA: Complete state and center data organized by time period
const StaticData = {
    "Last Day": {
        states: Object.keys(stateDummyData).map((stateKey, idx) => ({
            "#": idx + 1,
            "Center Name": stateKey.charAt(0).toUpperCase() + stateKey.slice(1),
            "Date": "2025-11-27",
            converted_lead: stateDummyData[stateKey].reduce((sum, c) => sum + c.converted_lead, 0),
            total_lead: stateDummyData[stateKey].reduce((sum, c) => sum + c.total_lead, 0),
            appointments: stateDummyData[stateKey].reduce((sum, c) => sum + c.appointments, 0),
            package_booked_snb: stateDummyData[stateKey].reduce((sum, c) => sum + c.package_booked_snb, 0),
            package_booked_sdt: stateDummyData[stateKey].reduce((sum, c) => sum + c.package_booked_sdt, 0),
            package_booked_snb_sdt: stateDummyData[stateKey].reduce((sum, c) => sum + c.package_booked_snb_sdt, 0),
            package_commpleted_snb: stateDummyData[stateKey].reduce((sum, c) => sum + c.package_commpleted_snb, 0),
            package_commpleted_sdt: stateDummyData[stateKey].reduce((sum, c) => sum + c.package_commpleted_sdt, 0),
            package_commpleted_snb_sdt: stateDummyData[stateKey].reduce((sum, c) => sum + c.package_commpleted_snb_sdt, 0),
            treatment_scheduled_snb: stateDummyData[stateKey].reduce((sum, c) => sum + c.treatment_scheduled_snb, 0),
            treatment_scheduled_sdt: stateDummyData[stateKey].reduce((sum, c) => sum + c.treatment_scheduled_sdt, 0),
            treatment_scheduled_snb_sdt: stateDummyData[stateKey].reduce((sum, c) => sum + c.treatment_scheduled_snb_sdt, 0),
            treatment_completed_snb: stateDummyData[stateKey].reduce((sum, c) => sum + c.treatment_completed_snb, 0),
            treatment_completed_sdt: stateDummyData[stateKey].reduce((sum, c) => sum + c.treatment_completed_sdt, 0),
            treatment_completed_snb_sdt: stateDummyData[stateKey].reduce((sum, c) => sum + c.treatment_completed_snb_sdt, 0),
            machines_snb: stateDummyData[stateKey].reduce((sum, c) => sum + c.machines_snb, 0),
            machines_sdt: stateDummyData[stateKey].reduce((sum, c) => sum + c.machines_sdt, 0),
            cui_snb: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.cui_snb, 0) / stateDummyData[stateKey].length),
            cui_sdt: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.cui_sdt, 0) / stateDummyData[stateKey].length),
        })),
        centers: stateDummyData
    },
    "Last Month": {
        states: Object.keys(stateDummyData).map((stateKey, idx) => ({
            "#": idx + 1,
            "Center Name": stateKey.charAt(0).toUpperCase() + stateKey.slice(1),
            "Date": "2025-10-27",
            converted_lead: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.converted_lead, 0) * 2.8),
            total_lead: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.total_lead, 0) * 2.8),
            appointments: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.appointments, 0) * 2.8),
            package_booked_snb: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.package_booked_snb, 0) * 2.8),
            package_booked_sdt: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.package_booked_sdt, 0) * 2.8),
            package_booked_snb_sdt: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.package_booked_snb_sdt, 0) * 2.8),
            package_commpleted_snb: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.package_commpleted_snb, 0) * 2.8),
            package_commpleted_sdt: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.package_commpleted_sdt, 0) * 2.8),
            package_commpleted_snb_sdt: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.package_commpleted_snb_sdt, 0) * 2.8),
            treatment_scheduled_snb: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.treatment_scheduled_snb, 0) * 2.8),
            treatment_scheduled_sdt: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.treatment_scheduled_sdt, 0) * 2.8),
            treatment_scheduled_snb_sdt: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.treatment_scheduled_snb_sdt, 0) * 2.8),
            treatment_completed_snb: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.treatment_completed_snb, 0) * 2.8),
            treatment_completed_sdt: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.treatment_completed_sdt, 0) * 2.8),
            treatment_completed_snb_sdt: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.treatment_completed_snb_sdt, 0) * 2.8),
            machines_snb: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.machines_snb, 0) * 2.8),
            machines_sdt: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.machines_sdt, 0) * 2.8),
            cui_snb: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.cui_snb, 0) / stateDummyData[stateKey].length),
            cui_sdt: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.cui_sdt, 0) / stateDummyData[stateKey].length),
        })),
        centers: Object.keys(stateDummyData).reduce((acc, stateKey) => {
            acc[stateKey] = stateDummyData[stateKey].map(center => ({
                ...center,
                "Date": "2025-10-27",
                converted_lead: Math.round(center.converted_lead * 2.8),
                total_lead: Math.round(center.total_lead * 2.8),
                appointments: Math.round(center.appointments * 2.8),
                package_booked_snb: Math.round(center.package_booked_snb * 2.8),
                package_booked_sdt: Math.round(center.package_booked_sdt * 2.8),
                package_booked_snb_sdt: Math.round(center.package_booked_snb_sdt * 2.8),
                package_commpleted_snb: Math.round(center.package_commpleted_snb * 2.8),
                package_commpleted_sdt: Math.round(center.package_commpleted_sdt * 2.8),
                package_commpleted_snb_sdt: Math.round(center.package_commpleted_snb_sdt * 2.8),
                treatment_scheduled_snb: Math.round(center.treatment_scheduled_snb * 2.8),
                treatment_scheduled_sdt: Math.round(center.treatment_scheduled_sdt * 2.8),
                treatment_scheduled_snb_sdt: Math.round(center.treatment_scheduled_snb_sdt * 2.8),
                treatment_completed_snb: Math.round(center.treatment_completed_snb * 2.8),
                treatment_completed_sdt: Math.round(center.treatment_completed_sdt * 2.8),
                treatment_completed_snb_sdt: Math.round(center.treatment_completed_snb_sdt * 2.8),
                machines_snb: Math.round(center.machines_snb * 2.8),
                machines_sdt: Math.round(center.machines_sdt * 2.8),
            }));
            return acc;
        }, {})
    },
    "Last Year": {
        states: Object.keys(stateDummyData).map((stateKey, idx) => ({
            "#": idx + 1,
            "Center Name": stateKey.charAt(0).toUpperCase() + stateKey.slice(1),
            "Date": "2024-11-27",
            converted_lead: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.converted_lead, 0) * 12),
            total_lead: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.total_lead, 0) * 12),
            appointments: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.appointments, 0) * 12),
            package_booked_snb: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.package_booked_snb, 0) * 12),
            package_booked_sdt: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.package_booked_sdt, 0) * 12),
            package_booked_snb_sdt: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.package_booked_snb_sdt, 0) * 12),
            package_commpleted_snb: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.package_commpleted_snb, 0) * 12),
            package_commpleted_sdt: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.package_commpleted_sdt, 0) * 12),
            package_commpleted_snb_sdt: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.package_commpleted_snb_sdt, 0) * 12),
            treatment_scheduled_snb: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.treatment_scheduled_snb, 0) * 12),
            treatment_scheduled_sdt: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.treatment_scheduled_sdt, 0) * 12),
            treatment_scheduled_snb_sdt: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.treatment_scheduled_snb_sdt, 0) * 12),
            treatment_completed_snb: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.treatment_completed_snb, 0) * 12),
            treatment_completed_sdt: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.treatment_completed_sdt, 0) * 12),
            treatment_completed_snb_sdt: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.treatment_completed_snb_sdt, 0) * 12),
            machines_snb: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.machines_snb, 0) * 12),
            machines_sdt: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.machines_sdt, 0) * 12),
            cui_snb: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.cui_snb, 0) / stateDummyData[stateKey].length),
            cui_sdt: Math.round(stateDummyData[stateKey].reduce((sum, c) => sum + c.cui_sdt, 0) / stateDummyData[stateKey].length),
        })),
        centers: Object.keys(stateDummyData).reduce((acc, stateKey) => {
            acc[stateKey] = stateDummyData[stateKey].map(center => ({
                ...center,
                "Date": "2024-11-27",
                converted_lead: Math.round(center.converted_lead * 12),
                total_lead: Math.round(center.total_lead * 12),
                appointments: Math.round(center.appointments * 12),
                package_booked_snb: Math.round(center.package_booked_snb * 12),
                package_booked_sdt: Math.round(center.package_booked_sdt * 12),
                package_booked_snb_sdt: Math.round(center.package_booked_snb_sdt * 12),
                package_commpleted_snb: Math.round(center.package_commpleted_snb * 12),
                package_commpleted_sdt: Math.round(center.package_commpleted_sdt * 12),
                package_commpleted_snb_sdt: Math.round(center.package_commpleted_snb_sdt * 12),
                treatment_scheduled_snb: Math.round(center.treatment_scheduled_snb * 12),
                treatment_scheduled_sdt: Math.round(center.treatment_scheduled_sdt * 12),
                treatment_scheduled_snb_sdt: Math.round(center.treatment_scheduled_snb_sdt * 12),
                treatment_completed_snb: Math.round(center.treatment_completed_snb * 12),
                treatment_completed_sdt: Math.round(center.treatment_completed_sdt * 12),
                treatment_completed_snb_sdt: Math.round(center.treatment_completed_snb_sdt * 12),
                machines_snb: Math.round(center.machines_snb * 12),
                machines_sdt: Math.round(center.machines_sdt * 12),
            }));
            return acc;
        }, {})
    }
}

// ✅ UTILITY: Generate row data for rendering
const generateRowData = (dataRow, columns) => {
    const result = {};
    columns.forEach(col => {
        if (col.key) {
            result[col.key] = dataRow[col.key];
        } else if (col.label === "#" || col.label === "Center Name" || col.label === "Date") {
            result[col.label] = dataRow[col.label];
        } else if (col.subColumns) {
            col.subColumns.forEach(subCol => {
                result[subCol.key] = dataRow[subCol.key];
            });
        }
    });
    return result;
};

// ✅ UTILITY: Generate row data without # and Center Name (for repeated rows)
const generateRowDataWithoutIdentifiers = (dataRow, columns) => {
    const result = {};
    columns.forEach(col => {
        if (col.label === "#" || col.label === "Center Name") {
            // Set blank for these columns instead of removing
            result[col.label] = "";
            return;
        }
        if (col.key) {
            result[col.key] = dataRow[col.key];
        } else if (col.label === "Date") {
            result[col.label] = dataRow[col.label];
        } else if (col.subColumns) {
            col.subColumns.forEach(subCol => {
                result[subCol.key] = dataRow[subCol.key];
            });
        }
    });
    return result;
};

// ✅ UTILITY: Get all column widths
const getColumnWidths = (columns) => {
    const widths = [];
    columns.forEach(col => {
        if (col.subColumns) {
            col.subColumns.forEach(subCol => {
                widths.push(subCol.width);
            });
        } else {
            widths.push(col.width);
        }
    });
    return widths;
};

// ✅ UTILITY: Get column widths without # and Center Name
const getColumnWidthsWithoutIdentifiers = (columns) => {
    const widths = [];
    columns.forEach(col => {
        if (col.label === "#" || col.label === "Center Name") {
            // Skip these columns
            return;
        }
        if (col.subColumns) {
            col.subColumns.forEach(subCol => {
                widths.push(subCol.width);
            });
        } else {
            widths.push(col.width);
        }
    });
    return widths;
};

// ✅ TABLE ROW COMPONENT
const TableRow = ({ data, widths, variant = "body" }) => {
    const cellValues = Object.values(data);
     const variantClass = {
        header: "bg-light fw-bold border text-dark",
        state_head: "bg-primary-300 text-primary border border-light",
        city_head: "bg-primary-100 text-primary border border-light",
        body: "bg-white text-dark border",
    }[ variant ];

    return (
        // <div style={{ display: 'flex', borderBottom: '1px solid #ddd' }}>
        //     {cellValues.map((value, idx) => (
        //         <div
        //             key={idx}
        //             style={{
        //                 width: widths[idx],
        //                 padding: '10px',
        //                 flexShrink: 0,
        //                 textAlign: 'center',
        //                 fontWeight: variant === "accordion" ? '600' : '400',
        //                 backgroundColor: variant === "accordion" ? '#f9f9f9' : 'white',
        //             }}
        //         >
        //             {value}
        //         </div>
        //     ))}
        // </div>

        <div className={`d-flex text-center ${variantClass}`}>
            {cellValues.map((cell, index) => (
                <div key={index} style={{ width: widths[ index ] || "120px" }} className="p-2 border-end">
                    {cell}
                </div>
            ))}
        </div>
    );
};

const CenterDailyReportStaticTable = () => {
    const [filtertedTableColumns] = useState(tableColumns);
    const [openPanels, setOpenPanels] = useState({});

    const widths = getColumnWidths(filtertedTableColumns);

    // ✅ Toggle accordion panel open/close
    const togglePanel = (panelId) => {
        setOpenPanels(prev => ({
            ...prev,
            [panelId]: !prev[panelId]
        }));
    };

    // ✅ Calculate state-level summary metrics by aggregating all centers in that state
    const getStateSummary = (stateKey) => {
        const centers = stateDummyData[stateKey] || [];
        const summary = {
            converted_lead: 0, total_lead: 0, appointments: 0,
            package_booked_snb: 0, package_booked_sdt: 0, package_booked_snb_sdt: 0,
            package_commpleted_snb: 0, package_commpleted_sdt: 0, package_commpleted_snb_sdt: 0,
            treatment_scheduled_snb: 0, treatment_scheduled_sdt: 0, treatment_scheduled_snb_sdt: 0,
            treatment_completed_snb: 0, treatment_completed_sdt: 0, treatment_completed_snb_sdt: 0,
            machines_snb: 0, machines_sdt: 0, cui_snb: 0, cui_sdt: 0,
        };

        centers.forEach(center => {
            Object.keys(summary).forEach(key => {
                summary[key] += center[key] || 0;
            });
        });

        return {
            "#": Object.keys(stateDummyData).indexOf(stateKey) + 1,
            "Center Name": stateKey.charAt(0).toUpperCase() + stateKey.slice(1),
            "Date": new Date().toISOString().split("T")[0],
            ...summary
        };
    };

    return (
        <div className="DailyReportTableTest pb-5">
            <div style={{ minWidth: widths.reduce((sum, w) => sum + parseFloat(w), 0) + 2 + 'px' }}>
                <TableHeader columns={filtertedTableColumns} />
                <div className="accordion" id="statesAccordion">
                    {/* ✅ STATE LEVEL ACCORDIONS */}
                    {Object.keys(stateDummyData).map((stateKey, stateIdx) => {
                        const stateData = getStateSummary(stateKey);
                        const statePanelId = `state-${stateIdx}`;
                        const isStateOpen = openPanels[statePanelId];

                        return (
                            <div key={statePanelId} className="accordion-item bg_sky">
                                <h2 className="accordion-header">
                                    <div
                                        className={`accordion-button ${isStateOpen ? '' : 'collapsed'} bg_sky`}
                                        style={{ padding: 0, display: 'flex', flexDirection: 'column', alignItems: 'stretch', height: 'auto' }}
                                        onClick={() => togglePanel(statePanelId)}
                                        type="button"
                                    >
                                        {/* ✅ THREE ROWS IN HEADER: LAST DAY, LAST MONTH, LAST YEAR */}
                                        {["Last Day", "Last Month", "Last Year"].map((period, idx) => {
                                            const periodData = StaticData[period];
                                            const stateStateData = periodData.states.find(s => s["Center Name"] === stateData["Center Name"]);
                                            
                                            if (!stateStateData) return null;
                                            
                                            // Replace Date with period label
                                            const stateRowData = {
                                                ...stateStateData,
                                                "Date": period
                                            };
                                            
                                            // Use full data for first row, without identifiers for others
                                            const rowData = idx === 0 
                                                ? generateRowData(stateRowData, filtertedTableColumns)
                                                : generateRowDataWithoutIdentifiers(stateRowData, filtertedTableColumns);
                                            
                                            return (
                                                <TableRow
                                                    key={period}
                                                    data={rowData}
                                                    widths={widths}
                                                    variant="state_head"
                                                />
                                            );
                                        })}
                                    </div>
                                </h2>
                                <div className={`accordion-collapse collapse ${isStateOpen ? 'show' : ''}`}>
                                    <div className="accordion-body p-0">
                                        {/* ✅ CENTER LEVEL NESTED ACCORDIONS */}
                                        <div className="accordion" id={`centersAccordion-${stateIdx}`}>
                                            {(stateDummyData[stateKey] || []).map((centerData, centerIdx) => {
                                                const centerPanelId = `center-${stateIdx}-${centerIdx}`;
                                                const isCenterOpen = openPanels[centerPanelId];
                                                
                                                // Get Last Day data for center header
                                                const centerLastDayData = StaticData["Last Day"].centers[stateKey]?.find(c => c["Center Name"] === centerData["Center Name"]);
                                                const centerHeaderData = {
                                                    ...(centerLastDayData || centerData),
                                                    "Date": "Last Day"
                                                };

                                                return (
                                                    <div key={centerPanelId} className="accordion-item m-0">
                                                        <h2 className="accordion-header">
                                                            <button
                                                                className={`accordion-button ${isCenterOpen ? '' : 'collapsed'}`}
                                                                style={{ padding: 0}}
                                                                onClick={() => togglePanel(centerPanelId)}
                                                                type="button"
                                                            >
                                                                <TableRow
                                                                    data={generateRowData(centerHeaderData, filtertedTableColumns)}
                                                                    widths={widths}
                                                                    variant="city_head"
                                                                />
                                                            </button>
                                                        </h2>
                                                        <div className={`accordion-collapse collapse ${isCenterOpen ? 'show' : ''}`}>
                                                            <div className="accordion-body p-0">
                                                                {/* ✅ SHOW LAST MONTH AND LAST YEAR FOR EACH CENTER */}
                                                                {["Last Month", "Last Year"].map((period) => {
                                                                    const periodData = StaticData[period];
                                                                    const centerPeriodData = periodData.centers[stateKey]?.find(c => c["Center Name"] === centerData["Center Name"]);
                                                                    
                                                                    if (!centerPeriodData) return null;
                                                                    
                                                                    // Replace Date with period label
                                                                    const centerRowData = {
                                                                        ...centerPeriodData,
                                                                        "Date": period
                                                                    };
                                                                    
                                                                    return (
                                                                        <TableRow
                                                                            key={`${centerPanelId}-${period}`}
                                                                            data={generateRowDataWithoutIdentifiers(centerRowData, filtertedTableColumns)}
                                                                            widths={widths}
                                                                            variant="body"
                                                                        />
                                                                    );
                                                                })}
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default CenterDailyReportStaticTable;
